<template>
  <v-navigation-drawer
    class="grey darken-4"
    dark
    permanent
    app
    :mini-variant="navToggle"
  >
    <v-list-item :class="navToggle && 'px-2'">
      <v-list-item-content>
        <v-btn v-if="navToggle" @click="navToggle = false" icon elevation="0">
          <v-icon>menu</v-icon>
        </v-btn>
        <v-list-item-title v-if="!navToggle" class="title">
          Service Dashboard
          <v-btn @click="navToggle = true" class="ml-2" icon elevation="0">
            <v-icon>menu_open</v-icon>
          </v-btn>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list nav>
      <template v-for="link in links">
        <v-list-item v-if="link.link" link :to="link.link">
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ link.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group v-else-if="link.children">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                {{ link.text }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-skeleton-loader
            v-if="link.children <= 0"
            type="button"
          ></v-skeleton-loader>
          <v-list-item
            v-for="child of link.children"
            :key="child.text"
            :to="child.link"
            dense
          >
            <v-list-item-icon>
              <v-icon v-if="child.icon">{{ child.icon }}</v-icon>
              <span v-if="child.inital">{{ child.inital }}</span>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                {{ child.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { fetchling } from '../hooks';

export default {
  data() {
    return {
      links: [
        {
          text: 'Data Tubes',
          icon: 'directions_railway',
          children: [],
        },
        {
          text: 'Legacy ORBC',
          icon: 'store',
          children: [
            { text: 'Contacts', link: '/orbc/contact', icon: 'contacts' },
            { text: 'Suppliers', link: '/orbc/supplier', icon: 'agriculture' },
            {
              text: 'Products',
              link: '/orbc/product',
              icon: 'shopping_basket',
            },
            {
              text: 'Product Specs',
              link: '/orbc/productSpec',
              icon: 'image_aspect_ratio',
            },
          ],
        },
        {
          text: 'Legacy',
          icon: 'museum',
          children: [
            { text: 'Assessments', link: '/assessments', icon: 'assessment' },
          ],
        },
      ],
      navToggle: false,
    };
  },
  async mounted() {
    const { dataTubes = [] } = await fetchling(
      'get-data-tubes',
      'resourcesList',
    );

    const datasourceLinks = [];
    const dataTubeTypes = [];

    for (const { resource, text, types } of dataTubes) {
      datasourceLinks.push({
        text,
        inital: (text || '').slice(0, 2),
        link: `/datatubes/${resource}`,
      });

      dataTubeTypes.push({
        client: resource,
        types,
      });
    }

    this.$store.commit('emptyClientsWebProcessors');
    this.$store.commit('emptyWebProcessorsTypes');

    this.$store.commit('setClientsWebProcessors', dataTubes);
    this.$store.commit('setWebProcessorsTypes', dataTubeTypes);

    datasourceLinks.push({
      icon: 'settings',
      text: 'Configurations',
      link: '/datatubes/config',
    });

    const dataTubesIndex = this.links.findIndex(
      pill => pill.text === 'Data Tubes',
    );

    this.links[dataTubesIndex].children.push(...datasourceLinks);
  },
};
</script>

<style lang="scss" scoped>
.v-skeleton-loader {
  ::v-deep .v-skeleton-loader__bone.v-skeleton-loader__button {
    width: 100%;
  }
}
</style>
